import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { translate } from '@smovilgps/optimus-intl';
import { Button, Checkbox, Col, Form, Input, Row, Select } from 'antd';
import PropTypes from 'prop-types';
import { COMMANDS_TYPE } from '../../constants/global';
import ListCommands from './ListCommands';

const FormItem = Form.Item;
const Option = Select.Option;

const CommandsForm = ({ form, commandTargetKeys, handleCommandChange, commandsTypes, removeCommand }) => {
	const intl = useIntl();
	const [commandType, setCommandType] = useState();
	const [commandText, setCommandText] = useState();
	const [isCustomerSupport, setIsCustomerSupport] = useState(false);

	const addCommand = (value) => {
		const command = {
			key: commandTargetKeys.length + 1,
			text: value,
			commandTypeId: commandType,
			isCustomerSupport,
		};
		setCommandType(COMMANDS_TYPE.DEFAULT);
		setCommandText('');
		setIsCustomerSupport(false);
		handleCommandChange(command);
	};

	const onAddCommandClick = () => {
		if (!commandText || !commandType) return false;
		addCommand(commandText);
	};

	const onTypeChange = (value) => {
		setCommandType(value);
	};

	const comandChange = (e) => {
		setCommandText(e.target.value);
	};

	const getCommandtypeName = (id) => {
		const commandType = commandsTypes.filter((cmdtype) => cmdtype.id === id);
		if (commandType.length > 0) return commandType[0].description;
		return '';
	};

	const onIsCustomerSupportChange = (e) => {
		e.preventDefault();
		setIsCustomerSupport(e?.target?.checked);
	};

	const CommandTypesOptions = commandsTypes
		.filter((commandsTypes) => {
			let commandsInUse = commandTargetKeys.map((cmdtypes) => cmdtypes.commandTypeId);
			return commandsInUse.indexOf(commandsTypes.id) < 0;
		})
		.map((commandsTypes) => (
			<Option key={`${commandsTypes.id}`} value={commandsTypes.id}>
				{commandsTypes.description}
			</Option>
		));
	return (
		<Form
			form={form}
			className="login-form col-8"
			layout={'vertical'}
			data-testid="commands-form"
			fields={[
				{ name: 'commandsType', value: commandType },
				{ name: 'description', value: commandText },
			]}
			preserve={false}
			initialValues={{
				commandsType: commandType ? commandType.id : null,
				description: commandText ? commandText.id : null,
			}}
		>
			<Row>
				<Col span={24}>
					<FormItem name="commandsType">
						<Select
							allowClear
							showArrow
							style={{ width: '100%' }}
							placeholder={intl.formatMessage(translate('selectCommands'))}
							className="commandFormRow"
							data-testid="select-commandType"
							showSearch
							filterOption={(input, option) =>
								option.children.toLowerCase().includes(input.trim().toLowerCase())
							}
							onChange={onTypeChange}
						>
							<Option key={0} value={0}>
								{intl.formatMessage(translate('selectCommandType'))}
							</Option>
							{CommandTypesOptions}
						</Select>
					</FormItem>
				</Col>
				<Col span={24}>
					<FormItem name="description">
						<Input
							placeholder={intl.formatMessage(translate('basicUsage'))}
							onChange={comandChange}
							data-testid="input-basicUsage"
							className="commandFormRow"
						/>
					</FormItem>
				</Col>
				<Col span={12}>
					<Button data-testid="btn-addCommand" className="commandFormRow" onClick={onAddCommandClick}>
						<FormattedMessage {...translate('add')} />
					</Button>
				</Col>
				<Col span={12}>
					<FormItem name="isCustomerSupport">
						<Checkbox
							data-testid="checkBox-isCustomerSupport"
							className="commandFormRow"
							checked={isCustomerSupport}
							onChange={onIsCustomerSupportChange}
						>
							<FormattedMessage {...translate('commandForCustomerSupport')} />
						</Checkbox>
					</FormItem>
				</Col>
			</Row>
			<ListCommands
				removeCommand={removeCommand}
				getCommandtypeName={getCommandtypeName}
				commandTargetKeys={commandTargetKeys}
			/>
		</Form>
	);
};

CommandsForm.propTypes = {
	form: PropTypes.object,
	commandTargetKeys: PropTypes.array.isRequired,
	handleCommandChange: PropTypes.func.isRequired,
	removeCommand: PropTypes.func.isRequired,
	commandsTypes: PropTypes.array.isRequired,
};

export default CommandsForm;
